import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFileInvoice, FaEnvelope, FaSpinner, FaClock, FaCheckCircle } from 'react-icons/fa';
import api from '../../services/api';
import './DashboardHome.css';

function DashboardHome() {
  const [stats, setStats] = useState({
    totalQuotes: 0,
    totalContacts: 0,
    recentQuotes: [],
    recentContacts: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [quotesRes, contactsRes] = await Promise.all([
        api.get('/api/admin/quotes'),
        api.get('/api/admin/contacts')
      ]);

      setStats({
        totalQuotes: quotesRes.data.length,
        totalContacts: contactsRes.data.length,
        recentQuotes: quotesRes.data.slice(0, 5),
        recentContacts: contactsRes.data.slice(0, 5)
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <FaSpinner className="spinner" />
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-home">
      <div className="dashboard-welcome">
        <h2>Welcome to V&R Courier Admin Dashboard</h2>
        <p>Monitor and manage all your quotes and customer inquiries</p>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card quotes-card">
          <div className="stat-icon">
            <FaFileInvoice />
          </div>
          <div className="stat-content">
            <h3>Total Quotes</h3>
            <p className="stat-number">{stats.totalQuotes}</p>
            <Link to="/admin/dashboard/quotes" className="stat-link">
              View All →
            </Link>
          </div>
        </div>

        <div className="stat-card contacts-card">
          <div className="stat-icon">
            <FaEnvelope />
          </div>
          <div className="stat-content">
            <h3>Total Contacts</h3>
            <p className="stat-number">{stats.totalContacts}</p>
            <Link to="/admin/dashboard/contacts" className="stat-link">
              View All →
            </Link>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="recent-activity-grid">
        {/* Recent Quotes */}
        <div className="recent-section">
          <div className="recent-header">
            <h3>
              <FaFileInvoice /> Recent Quotes
            </h3>
            <Link to="/admin/dashboard/quotes" className="view-all-link">
              View All
            </Link>
          </div>
          <div className="recent-list">
            {stats.recentQuotes.length === 0 ? (
              <p className="no-data">No quotes yet</p>
            ) : (
              stats.recentQuotes.map((quote) => (
                <Link
                  to={`/admin/dashboard/quotes/${quote._id}`}
                  key={quote._id}
                  className="recent-item"
                >
                  <div className="recent-item-content">
                    <h4>{quote.fullName}</h4>
                    <p className="recent-item-detail">
                      {quote.serviceType} • {quote.vehicleType}
                    </p>
                    <p className="recent-item-date">
                      <FaClock /> {formatDate(quote.createdAt)}
                    </p>
                  </div>
                  <FaCheckCircle className="recent-item-icon" />
                </Link>
              ))
            )}
          </div>
        </div>

        {/* Recent Contacts */}
        <div className="recent-section">
          <div className="recent-header">
            <h3>
              <FaEnvelope /> Recent Contacts
            </h3>
            <Link to="/admin/dashboard/contacts" className="view-all-link">
              View All
            </Link>
          </div>
          <div className="recent-list">
            {stats.recentContacts.length === 0 ? (
              <p className="no-data">No contact messages yet</p>
            ) : (
              stats.recentContacts.map((contact) => (
                <Link
                  to={`/admin/dashboard/contacts/${contact._id}`}
                  key={contact._id}
                  className="recent-item"
                >
                  <div className="recent-item-content">
                    <h4>{contact.name}</h4>
                    <p className="recent-item-detail">{contact.subject}</p>
                    <p className="recent-item-date">
                      <FaClock /> {formatDate(contact.createdAt)}
                    </p>
                  </div>
                  <FaCheckCircle className="recent-item-icon" />
                </Link>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;

